// Library Imports
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import ReactCountryFlag from 'react-country-flag';
import { Search } from '@mui/icons-material';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';

export const CountryDropDown = ({
    onCountryClick,
}) => {
    const countries = useSelector(state => state?.countriesAndStates?.countries)
    const [filteredCountries, setFilteredCountries] = useState(countries);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (searchTerm === '') {
            setFilteredCountries(countries);
        } else {
            const filtered = countries?.filter((country) =>
                country?.name?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredCountries(filtered);
        }
    }, [searchTerm, countries]);

    return (
        <Box
            component={'div'}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '270px',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px'
                },
                '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1'
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#d2d2d2',
                    borderRadius: '4px'
                }
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className='p-[0.56rem] top-0 sticky'>
                <TextField
                    sx={{
                        bgcolor: 'white',
                        borderColor: (theme) => theme.palette.grey['50'],
                        outline: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.08)',
                        width: '100%'
                    }}
                    variant="outlined"
                    placeholder={'Search Country'}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        )
                    }}
                />
            </div>

            {filteredCountries?.length === 0 ? (
                <div className='horizontal-center h-full px-[1.5rem] py-[2rem]'>
                    <p className='text-sm text-grey'>
                        Please add a valid country
                    </p>
                </div>
            ) : (
                <div className='flex flex-wrap gap-[1rem] px-[1rem] pt-[10px] mr-[0.5rem] overflow-auto'>
                    {filteredCountries?.map((country) => (
                        <div
                            key={country.countryId}
                            className='w-full sm:w-[48%] flex items-center cursor-pointer mb-[1.25rem]'
                            onClick={() => onCountryClick(country)}
                        >
                            <ReactCountryFlag
                                countryCode={
                                    country.countryCode === 'UK'
                                        ? 'GB'
                                        : country.countryCode
                                }
                                svg
                                style={{
                                    width: '2em',
                                    height: '2em'
                                }}
                                title={country.name}
                            />
                            <p className='text-base line-height-[1.6rem] pl-[0.75rem]'>
                                {country?.name}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </Box>
    );
}

